var _circle, _circle2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.24,
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#0094FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7.5,
    fill: "#0094FF",
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5272_47234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 8.66666H11.6667V7.33333H7.00004C6.63337 7.33333 6.33337 7.63333 6.33337 7.99999V11.6667H7.00004C7.00004 12.22 7.44671 12.6667 8.00004 12.6667C8.55337 12.6667 9.00004 12.22 9.00004 11.6667H11C11 12.22 11.4467 12.6667 12 12.6667C12.5534 12.6667 13 12.22 13 11.6667H13.6667V9.99999L12.6667 8.66666ZM8.00004 12.1667C7.72337 12.1667 7.50004 11.9433 7.50004 11.6667C7.50004 11.39 7.72337 11.1667 8.00004 11.1667C8.27671 11.1667 8.50004 11.39 8.50004 11.6667C8.50004 11.9433 8.27671 12.1667 8.00004 12.1667ZM12.5 9.16666L13.1534 9.99999H11.6667V9.16666H12.5ZM12 12.1667C11.7234 12.1667 11.5 11.9433 11.5 11.6667C11.5 11.39 11.7234 11.1667 12 11.1667C12.2767 11.1667 12.5 11.39 12.5 11.6667C12.5 11.9433 12.2767 12.1667 12 12.1667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5272_47234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartMarker);
export default __webpack_public_path__ + "static/media/start_marker.1fe908081fcd563a493c2c205c6a9995.svg";
export { ForwardRef as ReactComponent };